import axios from 'axios/index';
import React, {PureComponent} from 'react';

import {Classes, Overlay} from "@blueprintjs/core";
import toastr from 'toastr';
import {getCurrentUserId, getJwt} from '../../services/authService';
import http from '../../services/httpService';

export default class ClaimFreeNumberModal extends PureComponent {

    render() {
        return (
            <Overlay
                onClose={this.props.handleClose} className={Classes.OVERLAY_SCROLL_CONTAINER}
                isOpen={this.props.showModal}
                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field-payment"
                     style={{width: 500}}>
                    <div className="add-payment-method-modal-container">

                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={this.props.handleClose}><i
                                className="fas fa-times"></i></p>
                            <h2>Claim Free US Phone</h2>
                        </div>
                        <div className="modal-main">
                            <div className='margin-top-20 margin-bottom-20'>
                                {!this.props.showFreeNumberSuccessText ?
                                    <p>
                                        Are you sure you want to claim this phone <strong>{this.props.number}</strong> for
                                        free on your workspace <strong>{this.props.workspaceName}</strong>.
                                    </p>
                                    :
                                    <p>
                                        You have successfully claimed your free US Phone number: <strong>{this.props.number}</strong>.
                                    </p>
                                }


                            </div>
                            { !this.props.showFreeNumberSuccessText ?
                                <div className='justify-content-space flex-direction-row margin-bottom-20'>
                                    <button
                                        disabled={ false }
                                        onClick={ () => {
                                            this.props.handleClose()
                                        } }
                                        name="cancel_delete_tag"
                                        id="cancel_delete_tag"
                                        type="button"
                                        className='btn-white-border'>Cancel
                                    </button>
                                    { this.props.loaderActive ?
                                        <button
                                            disabled={ true }
                                            type="button"
                                            className='btn-action  btn-spinner'>Claim Phone <i
                                            className='fa fa-spin fa-spinner'></i></button>
                                        :
                                        <button
                                            disabled={ false }
                                            onClick={ this.props.handleClaimNumber }
                                            type="button"
                                            className='btn-action'>Claim Phone</button>
                                    }

                                </div>
                                :
                                <div className='justify-content-space flex-direction-row margin-bottom-20'>
                                    <button
                                        disabled={ false }
                                        onClick={ this.props.handleGoBack }
                                        name="cancel_delete_tag"
                                        id="cancel_delete_tag"
                                        type="button"
                                        className='btn-white-border'>Go back
                                    </button>

                                    <button
                                        disabled={ false }
                                        onClick={ this.props.handleContinuePurchase }
                                        type="button"
                                        className='btn-action'>Continue purchase</button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}